import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";

import BadiLogo from "components/Icons/BadiLogo";

import { getRelativePath } from "base/shared/Utils";
import { getOverviewPath } from "Sections/overview/routes";
import { DESKTOP_SCREEN_SIZE, MOBILE_SCREEN_SIZE } from "lib/styles-helpers";

import { LogoWrapper } from "./styled-components";

const Logo = ({
  updateShowDistribution,
  lister,
  hideOn,
  dataQa,
  color,
  ...rest
}) => {
  const homeLinkPath = lister ? getOverviewPath() : "/";
  const checkDistributionNav = () => {
    updateShowDistribution(true);
  };
  return (
    <LogoWrapper data-qa={dataQa} hideOn={hideOn}>
      <Link
        onClick={checkDistributionNav}
        to={getRelativePath(homeLinkPath)}
        {...rest}
      >
        <BadiLogo color={color} />
      </Link>
    </LogoWrapper>
  );
};

Logo.propTypes = {
  color: PropTypes.string,
  dataQa: PropTypes.string,
  hideOn: PropTypes.oneOf([DESKTOP_SCREEN_SIZE, MOBILE_SCREEN_SIZE]),
  lister: PropTypes.bool,
  updateShowDistribution: PropTypes.func.isRequired,
};

Logo.defaultProps = {
  color: null,
  dataQa: "logo-badi",
  hideOn: null,
  lister: false,
};

export default Logo;
